import React from 'react';
import Pill from '../Pill';

const LegsCell = ({ row }) => {
    const legs = row.original.legs || [];
    if (!legs.length) {
        return <span className="text-sm text-muted">-</span>;
    }

    return (
        <div className="flex flex-wrap justify-center gap-1">
            {legs.map((leg) => (
                <Pill key={leg} tone="leg">
                    {leg}
                </Pill>
            ))}
        </div>
    );
};

export default LegsCell;
